/**
 * Main entry point for the Zerv Admin Dashboard application
 * Initializes Vue app with all necessary plugins and configurations
 */

import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";

// Import global styles
import "./style.css";

// Create Vue app
const app = createApp(App);

// Create and configure Pinia store
const pinia = createPinia();
app.use(pinia);

// Use router
app.use(router);

// Initialize user store and setup router guards
import { useUserStore } from "./stores/user";
import { setupRouterGuards } from "./router/guards";

// Initialize user store
const userStore = useUserStore();
userStore.initializeAuth();

// Handle redirect result after Google Sign-In redirect
userStore.handleRedirectResult();

// Setup router guards
setupRouterGuards(router);

// Global error handler
app.config.errorHandler = (err, vm, info) => {
  console.error("Global error:", err, info);
  // You can add error reporting service here
};

// Mount the app
app.mount("#app");
